import React from "react";
import AuthData from "lib/authData";
import { subscribeToAuthChanges } from "lib/authChange";

export default Component =>
  class extends React.Component {
    // CD-8740: the cached profile is read on render, so when the boot probe's late
    // result changes it (after first paint) this must be told to render again —
    // otherwise the route guards built on it (OnlyPublic, Private, Home) keep
    // showing the screen for the profile they first saw.
    componentDidMount = () => {
      this.unsubscribe = subscribeToAuthChanges(() => this.forceUpdate());
    };

    componentWillUnmount = () => {
      if (this.unsubscribe) this.unsubscribe();
    };

    render = () => {
      const authData = AuthData.get();

      return <Component {...this.props} currentUser={authData && authData.user} />;
    };
  };
